import { OnboardingVerificationStatus } from "@/constants/compliance";

export enum OnboardingStage {
    WELCOME = "welcome",
    ORGANISATIONS = "organisations",
    CONTRACTS = "contracts",
    KYC = "kyc",
    USERS = "users",
    COMPLETED = "completed",
}

export const onboardingSteps = [
    {
        id: OnboardingStage.ORGANISATIONS,
        title: "Configured Organisations",
        description: "See a list of your configured organisations.",
    },
    {
        id: OnboardingStage.CONTRACTS,
        title: "Contracts",
        description: "Review and sign the esenda contracts.",
    },
    {
        id: OnboardingStage.KYC,
        title: "Complete KYC",
        description: "Complete KYC for each organisation.",
    },
    {
        id: OnboardingStage.USERS,
        title: "Create Users",
        description: "Add other members to access the platform.",
    },
] as const;

export const onboardingStages = [
    OnboardingStage.WELCOME,
    ...onboardingSteps.map(({ id }) => id),
    OnboardingStage.COMPLETED,
] as const;

export const isKycSubmitted = (status: string | null | undefined): boolean =>
    status === OnboardingVerificationStatus.PENDING_VERIFICATION ||
    status === OnboardingVerificationStatus.VERIFICATION_COMPLETE ||
    status === OnboardingVerificationStatus.ONBOARDING_COMPLETE;
